import "./index.scss";
import { AlgoliaProvider } from "@wise-emotions/react-algolia";
import { Translations } from "types/types";
import { useSiteContext } from "context/SiteProvider";
import React from "react";
import SearchLight from "../Light";

const PROJECT_ID = process.env.GATSBY_ALGOLIA_PROJECT_ID;
const SEARCH_API_KEY = process.env.GATSBY_ALGOLIA_SEARCH_API_KEY;
const INDEX_NAME = process.env.GATSBY_ALGOLIA_INDEX_NAME;

interface Props {
  currentLang: string;
  searchPageSlug: string;
  text: string;
  translations: Translations[];
}

const SearchOverlay = ({
  translations,
  currentLang,
  searchPageSlug,
  text,
}: Props) => {
  // @ts-expect-error attend useSiteContext TS
  const { state } = useSiteContext();
  return (
    <AlgoliaProvider
      applicationId={PROJECT_ID}
      searchApiKey={SEARCH_API_KEY}
      indexName={INDEX_NAME}
      configureProps={{ hitsPerPage: 4, facetFilters: [`lang:${currentLang}`] }}
      minChars={state?.minCharsSearch}
    >
      <div className="SearchOverlay">
        <SearchLight
          translations={translations}
          lang={currentLang}
          searchPageUrl={`/${currentLang}/${searchPageSlug}`}
          text={text}
        />
      </div>
    </AlgoliaProvider>
  );
};

export default SearchOverlay;
